import React, { Fragment } from 'react';
import { Link } from 'gatsby';
import shortid from 'shortid';

import Button from 'components/button';
import { CTAS } from 'context/solutions/constants';

export const getCTAs = ctaList => {
  const signUpButton = (
    <Button tag={Link} to="/register" buttonColor="red">
      SignUp
    </Button>
  );
  const openLiveAccountButton = (
    <Button tag={Link} to="/register" buttonColor="red">
      Open Live Account
    </Button>
  );
  const readMoreButton = (
    <Button tag={Link} to="/register" buttonColor="grayInverted">
      Read More
    </Button>
  );
  const startTradingButton = (
    <Button tag={Link} to="/register" buttonColor="red">
      Start Trading
    </Button>
  );
  const requestDemoButton = (
    <Button tag={Link} to="/demo" buttonColor="gray">
      Request Demo
    </Button>
  );
  const tryDemoButton = (
    <Button tag={Link} to="/demo" buttonColor="gray">
      Try Demo
    </Button>
  );
  const chooseDatesButton = (
    <Button tag={Link} to="/demo" buttonColor="gray">
      Choose Dates
    </Button>
  );
  const viewProgressButton = (
    <Button tag={Link} to="/demo" buttonColor="grayInverted">
      View Progress
    </Button>
  );

  const CTAS_MAP = {
    [CTAS.READ_MORE]: readMoreButton,
    [CTAS.REQUEST_DEMO]: requestDemoButton,
    [CTAS.CHOOSE_DATES]: chooseDatesButton,
    [CTAS.START_TRADING]: startTradingButton,
    [CTAS.VIEW_PROGRESS]: viewProgressButton,
    [CTAS.SIGN_UP]: signUpButton,
    [CTAS.TRY_DEMO]: tryDemoButton,
    [CTAS.OPEN_LIVE_ACCOUNT]: openLiveAccountButton,
  };

  return ctaList.map(cta => (
    <Fragment key={shortid()}>{CTAS_MAP[cta]}</Fragment>
  ));
};
